<div class="relative aspect-video w-full">
  <img
    #currentImageRef
    class="absolute inset-0 h-full w-full object-cover"
    (click)="showGallery()"
    [src]="currentImage.thumbUrl"
    (swipeleft)="nextImage()"
    (swiperight)="previousImage()"
  />

  @if (loadingImage) {
    <div
      class="absolute inset-0 flex items-center justify-center bg-interface-surface-100"
    >
      <ag1-loader classOverrides="h-20! w-20!" />
    </div>
  }

  @if (images().length > 1) {
    <p-button
      class="absolute left-1 top-1/2 z-10 -translate-y-1/2"
      severity="secondary"
      size="small"
      ariaLabel="Previous image"
      [rounded]="true"
      (onClick)="previousImage()"
    >
      <ng-template #icon>
        <svg-icon src="/assets/icons/general/chevron-left.svg" />
      </ng-template>
    </p-button>
    <p-button
      class="absolute right-1 top-1/2 z-10 -translate-y-1/2"
      severity="secondary"
      size="small"
      ariaLabel="Next image"
      [rounded]="true"
      (onClick)="nextImage()"
    >
      <ng-template #icon>
        <svg-icon src="/assets/icons/general/chevron-right.svg" />
      </ng-template>
    </p-button>
  }
</div>

<p-galleria
  [value]="images()"
  [(visible)]="galleryIsOpen"
  [(activeIndex)]="galleryIndex"
  [fullScreen]="true"
  [circular]="true"
  [showThumbnails]="false"
  [showItemNavigators]="images().length > 1"
>
  <ng-template #item let-image>
    <img [src]="image.url" class="block max-h-[80vh] max-w-[80vw]" />
  </ng-template>
</p-galleria>
